import { createFileRoute } from "@tanstack/react-router"
import { LegalPrivacyPage } from "@/components/legal-pages"

export const Route = createFileRoute("/privacy")({
  component: LegalPrivacyPage,
})
